import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import featureEnabled from 'shared/helper/feature';
import { BANK_TRANSFER, BOLETO, CREDITS } from 'researcher/domain/transaction/payment-method';
import { getAccessType, getNewPurchaseStartDate, getPurchaseInformation } from '../reducer';
import { loadDigitalEditing } from '../actions';
import DigitalEditPayment from './DigitalEditPayment';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var application = _ref.application,
    user = _ref.user,
    payment = _ref.payment,
    digitalEdit = _ref.digitalEdit;
  var match = _ref2.match;
  return {
    accessType: getAccessType({
      digitalEdit: digitalEdit
    }),
    allowsDigitalEditing: application.allowsDigitalEditing,
    checkForDigitalEditingPurchase: !!match.params.success,
    convertNumberOfInstallments: user.currency !== 'USD',
    currency: user.currency,
    digitalEditEnabled: !!digitalEdit.digitalEditingPurchase,
    availableDigitalPurchases: digitalEdit.availableDigitalPurchases,
    excludePaymentMethods: [BANK_TRANSFER, BOLETO, CREDITS],
    hasDigitalEditingPurchase: digitalEdit.hasDigitalEditingPurchase,
    isCurieLaunched: featureEnabled('curie_is_launched'),
    newPurchaseStartDate: getNewPurchaseStartDate({
      digitalEdit: digitalEdit
    }),
    paymentStatus: payment.status,
    receiptCode: payment.receiptCodes.digital,
    status: digitalEdit.status,
    purchaseInformation: getPurchaseInformation({
      application: application,
      match: match,
      digitalEdit: digitalEdit
    })
  };
};
var mapDispatchToProps = {
  loadDigitalEditing: loadDigitalEditing
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DigitalEditPayment));